<template>
  <div class="mainBox">
    <div class="mainContent">
      <a-breadcrumb>
        <a-breadcrumb-item>主頁</a-breadcrumb-item>
        <a-breadcrumb-item>
          <router-link :to="{path:'/voucher'}">Voucher</router-link>
        </a-breadcrumb-item>
      </a-breadcrumb>
      <div class="main-search">
        <div class="search-choose">
          <h4 class="choose-title">請選擇Voucher類別:</h4>
          <div class="button-wrap">
            <button
              v-for="(item,index) in chooseList"
              :key="index"
              :class="['choose-btn',curren === index ? 'active' : '']"
              @click="curren = index"
            >{{item}}</button>
          </div>
        </div>
        <div class="search-input-wrap">
          <label for="search">
            <a-icon type="search" />
            <input
              id="search"
              type="text"
              class="search-input"
              placeholder="Type Any here...."
            >
          </label>
        </div>
      </div>
      <!-- 本週新Voucher区域 -->
      <div class="newWeekVoucher">
        <div class="title-wrap">
          <h3 class="title">本週新Voucher</h3>
          <div class="titleUnderline"></div>
        </div>
        <div class="content">
          <VueSlickCarousel
            :arrows="weekCarouselRows !== 1"
            :rows="weekCarouselRows"
            v-if="weekCarousel.length !== 0"
          >
            <div
              v-for="item in weekCarousel"
              :key="item.couponId"
              class="card"
            >
              <div class="card-title">
                <img
                  :src="item.detailBannerUrl"
                  alt=""
                >
                <button
                  class="addCart"
                  @click="addCart(item)"
                >
                  <i class="iconfont icon-shopping"></i>
                </button>
              </div>
              <div class="card-body">
                <div class="body-title-row">
                  <span class="title">{{item.name}}</span>
                  <span class="title-logo">
                    <img
                      src="@/assets/images/giftCard.png"
                      alt=""
                    >
                  </span>
                </div>
                <div class="body-info-wrap">
                  <div class="info-price-row">
                    <div class="newPrice">
                      <span>$</span>
                      <strong>50</strong>
                    </div>
                    <div class="oldPrice">
                      $100
                    </div>
                  </div>
                  <div class="discount-row">
                    <div class="discount">
                      <span>{{item.amount}}{{item.symbol}}</span>
                    </div>
                    <div class="discount-buyers">
                      <i class="iconfont icon-yonghu"></i>
                      {{item.amount}}K+已售
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </VueSlickCarousel>
        </div>
      </div>

      <!-- 精選Voucher区域 -->
      <div class="selectedVoucher">
        <div class="title-wrap">
          <h3 class="title">精選Voucher</h3>
          <div class="titleUnderline"></div>
        </div>
        <div class="content">
          <div
            v-for="item in weekCarousel"
            :key="item.couponId"
            class="card"
          >
            <div class="card-title">
              <img
                :src="item.detailBannerUrl"
                alt=""
              >
              <button
                class="addCart"
                @click="addCart(item)"
              >
                <i class="iconfont icon-shopping"></i>
              </button>
            </div>
            <div class="card-body">
              <div class="body-title-row">
                <span class="title">{{item.name}}</span>
                <span class="title-logo">
                  <img
                    src="@/assets/images/giftCard.png"
                    alt=""
                  >
                </span>
              </div>
              <div class="body-info-wrap">
                <div class="info-price-row">
                  <div class="newPrice">
                    <span>$</span>
                    <strong>50</strong>
                  </div>
                  <div class="oldPrice">
                    $100
                  </div>
                </div>
                <div class="discount-row">
                  <div class="discount">
                    <span>{{item.amount}}{{item.symbol}}</span>
                  </div>
                  <div class="discount-buyers">
                    <i class="iconfont icon-yonghu"></i>
                    {{item.amount}}K+已售
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <button class="showMore">
          <a-icon type="right" />
          顯示更多
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import {
  getWeekCoupons
} from '@/api/coupon'
import { mapMutations } from 'vuex'
import VueSlickCarousel from 'vue-slick-carousel'
import 'vue-slick-carousel/dist/vue-slick-carousel.css'
// optional style for arrows & dots
import 'vue-slick-carousel/dist/vue-slick-carousel-theme.css'

export default {
  data () {
    return {
      curren: null,
      chooseList: ['Dining', 'Entertainment', 'Health', 'Shopping'],
      weekCarouselRows: 4,
      weekCarousel: [],
      // resize事件
      resizeFn: null
    }
  },
  methods: {
    // 防抖函数
    debounce (fn, delay) {
      let timer = null
      return () => {
        if (timer) {
          clearTimeout(timer)
        }
        timer = setTimeout(fn, delay)
      }
    },
    getRows () {
      // 得到屏幕宽度
      const width = window.innerWidth
      if (width > 1200) {
        this.weekCarouselRows = 4
      } else if (width > 997) {
        this.weekCarouselRows = 3
      } else if (width > 768) {
        this.weekCarouselRows = 2
      } else {
        this.weekCarouselRows = 1
      }
    },
    async getVoucher () {
      const res = await getWeekCoupons()
      this.weekCarousel = res.list
    },
    ...mapMutations('cart', [
      'addCart'
    ])
  },
  created () {
    this.getVoucher()
  },
  mounted () {
    // 添加屏幕监听
    this.getRows()
    this.resizeFn = this.debounce(this.getRows, 200)
    window.addEventListener('resize', this.resizeFn)
  },
  beforeDestroy () {
    window.removeEventListener('resize', this.resizeFn)
  },
  components: {
    VueSlickCarousel
  }
}

</script>

<style lang="scss" scoped>
$theme-color: #d4517e;
.mainBox {
  padding-top: 80px;
  background-color: rgb(245, 245, 245);
}
.mainContent {
  text-align: left;
  max-width: 1280px;
  margin: 0 auto;
  padding: 15px;
}

.main-search {
  padding: 36px 0 40px;
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  align-items: flex-end;
  .search-choose {
    .choose-title {
      font-family: Roboto;
      font-weight: 500;
      font-size: 20px;
      color: $theme-color;
    }
    .button-wrap {
      margin: 0 -6px;
      .choose-btn {
        margin-bottom: 17px;
        margin: 0 6px 17px;
        padding: 5px 23px;
        font-size: 16px;
        color: $theme-color;
        background-color: #fff;
        border: 1px solid$theme-color;
        outline: none;
        border-radius: 6px;
        transition: all 0.2s;
        &:hover {
          color: #fff;
          background-color: $theme-color;
        }
        &[class*="active"] {
          color: #fff;
          background-color: $theme-color;
        }
      }
    }
  }
  .search-input-wrap {
    margin-bottom: 17px;
    padding-bottom: 5px;
    border-bottom: 1px solid #b1b1b1;
    > label {
      display: flex;
      align-items: flex-end;
    }
    .anticon-search {
      margin-right: 10px;
      font-size: 30px;
      color: #6f6f6f;
    }
    .search-input {
      padding: 0;
      font-size: 16px;
      background: transparent;
      border: none;
      outline: none;
    }
  }
}

.title-wrap {
  margin-bottom: 20px;
  .title {
    font-family: Noto Sans CJK TC;
    font-weight: bold;
    font-size: 24px;
    color: $theme-color;
  }
}

.newWeekVoucher {
  margin-bottom: 60px;
  ::v-deep .slick-slider {
    .slick-arrow {
      &::before {
        font-size: 38px;
        color: #949494;
      }
    }
    .slick-prev {
      left: 0;
      margin-left: -40px;
      &::before {
        right: 0;
      }
    }
    .slick-next {
      right: -20px;
      &::before {
        right: 0;
      }
    }
    .slick-slide {
      padding: 0 -10px;
      display: flex;
      > div {
        flex: 1;
        padding: 0 10px;
        &:first-of-type {
          padding: 0 10px 0 0;
        }
        &:last-of-type {
          padding: 0 0 0 10px;
        }
      }
    }
    @media screen and (min-width: 1420px) {
      margin: 0 auto;
      .slick-prev {
        left: 0;
        margin-left: -60px;
        &::before {
          right: 0;
        }
      }
      .slick-next {
        right: -40px;
        &::before {
          right: 0;
        }
      }
    }
    @media screen and (max-width: 1420px) {
      width: calc(1280px - 100px);
      margin: 0 auto;
    }
    @media screen and (max-width: 1280px) {
      width: calc(100% - 50px);
    }
    @media screen and (max-width: 768px) {
      width: 100%;
      .slick-slide {
        padding: 0;
        > div {
          padding: 0;
          &:first-of-type {
            padding: 0;
          }
          &:last-of-type {
            padding: 0;
          }
        }
      }
    }
  }
}
.card {
  height: 100%;
  min-height: 300px;
  border-radius: 4px;
  overflow: hidden;
  border: none;
  transition: all 0.4s ease;
  cursor: pointer;
  &:hover {
    transform: scale(1.05);
  }
  .card-title {
    > img {
      width: 100%;
      max-height: 130px;
      object-fit: cover;
    }
    .addCart {
      width: 30px;
      height: 30px;
      position: absolute;
      top: 10px;
      right: 15px;
      color: $theme-color;
      border-radius: 50%;
      background-color: #fff;
      border: none;
      outline: none;
      &:hover {
        background-color: rgb(245, 239, 239);
      }
      &:active {
        opacity: 0.8;
      }
      > .iconfont {
        font-size: 20px;
      }
    }
  }
  .card-body {
    padding: 0px 20px 20px;
    .body-title-row {
      display: flex;
      justify-content: space-between;
      .title {
        font-size: 14px;
      }
      .title-logo {
        max-width: 60px;
        > img {
          width: 100%;
        }
      }
    }
    .body-info-wrap {
      display: flex;
      justify-content: space-between;
      align-items: flex-end;
      .info-price-row {
        color: $theme-color;
        .newPrice {
          display: flex;
          align-items: center;
          > span {
            font-size: 20px;
          }
          > strong {
            font-size: 42px;
          }
        }
        .oldPrice {
          font-size: 16px;
          text-decoration: line-through;
        }
      }
      .discount-row {
        .discount {
          text-align: center;
          color: $theme-color;
          > span {
            padding: 3px 14px;
            font-size: 13px;
            border-radius: 30px;
            border: 1px solid$theme-color;
          }
        }
        .discount-buyers {
          margin-top: 5px;
          font-size: 14px;
          color: #747474;
        }
      }
    }
  }
}

.selectedVoucher {
  .content {
    display: flex;
    flex-wrap: wrap;
    margin: 0 -10px;
    .card {
      @media screen and (max-width: 1200px) {
        width: calc(33% - 20px);
      }
      @media screen and (max-width: 997px) {
        width: calc(50% - 20px);
      }
      @media screen and (max-width: 768px) {
        width: 100%;
      }
      @media screen and (min-width: 1200px) {
        width: calc(25% - 20px);
      }
      margin: 10px;
      box-shadow: 0px 4px 20px rgba(0, 0, 0, 0.1);
    }
  }
  .showMore {
    display: flex;
    justify-content: center;
    align-items: center;
    margin: 30px auto 70px;
    padding: 8px 30px;
    color: $theme-color;
    background: #ffffff;
    border: 1px solid $theme-color;
    box-sizing: border-box;
    border-radius: 6px;
    outline: none;
    transition: all 0.4s ease;
    > .anticon-right {
      margin-right: 10px;
    }
    &:hover {
      color: #fff;
      background-color: $theme-color;
    }
    &:active {
      opacity: 0.8;
    }
  }
}
</style>
